define(function (require) {
    "use strict";

    var LE = require("app");
    var Config = require("assets/config/entities/config.json");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var Dialog = require("ui/dialog/Dialog");

    var UserListLayout = require("user-management-views/users/UserListLayout");
    var UsersGridView = require("user-management-views/users/UsersGridView");
    var UsersWithProfilesGridView = require("user-management-views/users/UsersWithProfilesGridView");
    var UsersAssignSkillDialogView = require("user-management-views/users/UsersAssignSkillDialogView");
    var UsersSetConcurrencyDialogView = require("user-management-views/users/UsersSetConcurrencyDialogView");
    var UsersGridModel = require("user-management-models/UsersGridModel");
    var ProfileModel = require("models/entities/ProfileModel");
    var UserListComparators = require("user-management-comparators/UserListComparators");
    var UserManagementUtilities = require("user-management-utils/UserManagementUtilities");
    var ModuleAwareNotificationManager = require("src/controllers/ModuleAwareNotificationManager");
    var SecureUtilities = require("infra-util/SecureUtilities");
    var SettingsCollection = require("collections/SettingsCollection");

    var UsersFilters = require("user-management-filters/UsersFilters");
    var CONST = require("const");
    var DEFAULT_COMPARATOR = function(model){
        return model.getDisplayName();
    };
    var DEFAULT_ORDERBY = "asc";
    var PAGE_SIZE = 25;

    var UserListController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserListController = Marionette.Controller.extend({
            searchStringValue: "",
            dataInitialized: false,
            viewInitialized: false,

            initialize: function (options) {
                this._initialize(options);
            },

            getView: function (options) {
                return this._getView(options);
            },
            onNavigateOut: function(){
                this._onNavigateOut();
            },

            _initialize: function (options) {
                LEUserManagement.logger.debug("_initialize", "UserWithProfilesListController:_initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_LIST);
                this.usersGridModel = new UsersGridModel();
                this.usersNotificationManager = new ModuleAwareNotificationManager({
                    module: LEUserManagement,
                });
                this.isBlockAddAndDuplicateUsers = LE.siteSettings.customizationSettings.isBlockAddUsers();
                this.hasBatchUpdates = LEUserManagement.hasBatchUpdates();
                this._initTooltipsText();
                this._initErrorMessagesMap();
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                LEUserManagement.logger.debug("_bindEventsChannel", "UserWithProfilesListController:_bindEventsChannel");
                this.listenTo(this.channel, "paging:change", this._onPagingChange);
                this.listenTo(this.channel, "paging:clear", this._onPagingClear);
                this.listenTo(this.channel, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel, "row:click", this._onRowClick);
                this.listenTo(this.channel, "actionMenu:select", this._onActionMenuSelect);
                this.listenTo(this.channel, "search:initiate", this._onSearchRequest);
                this.listenTo(this.channel, "search:updateValue", this._updateSearchString);
            },

            _getView: function(options) {
                LEUserManagement.logger.debug("_getView", "UserWithProfilesListController:_getView");
                this._unbindEventsDataAndViews();
                this._initData(options);
                this._initViews();
                this._bindEventsDataAndViews();
                return this.userListLayout;
            },

            _initData: function(options) {
                LEUserManagement.logger.debug("_initData", "UserWithProfilesListController:_initData");
                if (!this.dataInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all data once", "UserWithProfilesListController:_initData");
                    this.profilesCollection = LEUserManagement.getDataManager().getProfilesCollection();
                    this.usersGridModel.setProfiles(this.profilesCollection);
                    this.usersGridModel.setAvailableRoles(ProfileModel.ROLES_BY_IDS);
                    this.agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                    this.usersGridModel.setAgentGroups(this.agentGroupsCollection);
                    this.skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();

                    this.usersCollection = LEUserManagement.getDataManager().getUsersCollection();
                    this.usersSelectableCollection = SelectableCollectionDecorator.decorate(this.usersCollection);
                    this.usersOrganizedCollection = OrganizeCollectionDecorator.decorate(this.usersSelectableCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });

                    this.usersOrganizedCollection.reset(); //start the table collection empty until the first organize call, do not worry original is still full.


                    this.settingsCollection = LEUserManagement.getDataManager().getSiteSettingsUserList();
                    this.dataInitialized = true;
                }

            },

            _initViews: function() {
                LEUserManagement.logger.debug("_initViews", "UserWithProfilesListController:_initViews");
                if (!this.viewInitialized) {
                    LEUserManagement.logger.debug("_initData - initializing all views once", "UserWithProfilesListController:_initViews");
                    var acUsersAccount = LE.siteSettings.accountSettings.isAcUser();
                    var exportAcUsersData = UserManagementUtilities.hasExportAcUsersData();

                    this.userListLayout = new UserListLayout({
                        displayAcUsersExport: (exportAcUsersData && acUsersAccount),
                        searchStringValue: this.searchStringValue,
                        usersCollection: this.usersOrganizedCollection,
                        displayAcUsersDuplicate: !this.isBlockAddAndDuplicateUsers,
                        displayAcUsersAdd: !this.isBlockAddAndDuplicateUsers,
                        displayAssignSkills: this.hasBatchUpdates,
                        displaySetConcurrency: this.hasBatchUpdates,
                        showClearSelection: this.hasBatchUpdates,
                    });

                    if (LE.sessionManager.hasProfilesFeature()) {
                        this.usersGridView = new UsersWithProfilesGridView({
                            collection: this.usersOrganizedCollection,
                            selectableCollection: this.usersSelectableCollection,
                            settingsCollection: this.settingsCollection,
                            model: this.usersGridModel,
                            filters: UsersFilters,
                            comparators: UserListComparators,
                            isShowLoader: true,
                            textLoader: {
                                filtering: UsersWithProfilesGridView.LOADER_TEXT.FILTERING,
                                sorting: UsersWithProfilesGridView.LOADER_TEXT.SORTING
                            },
                            isShowAnimation: false
                        });
                    }
                    else {
                        this.usersGridView = new UsersGridView({
                            collection: this.usersOrganizedCollection,
                            settingsCollection: this.settingsCollection,
                            model: this.usersGridModel,
                            filters: UsersFilters,
                            comparators: UserListComparators,
                            isShowLoader: true,
                            textLoader: {
                                filtering: UsersGridView.LOADER_TEXT.FILTERING,
                                sorting: UsersGridView.LOADER_TEXT.SORTING
                            },
                            isShowAnimation: false
                        });
                    }

                    this.viewInitialized = true;
                }

                this.usersGridView.setGroupsColumnVisibility(this._isGroupColumnVisible());
                this.usersGridView.setUserTypeVisibility(this._isUserTypeColumnVisible());
                this.usersGridView.setLobsColumnVisibility(this._isLobsColumnVisible());
            },

            _bindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_bindEventsDataAndViews", "UserWithProfilesListController:_bindEventsDataAndViews");
                this.listenTo(this.userListLayout, "render", this._onLayoutRender);
                this.listenTo(this.userListLayout, "show", this._onLayoutShown);  //listen to show not render ( we are using region add - this will trigger every time the view is seen )
                this.listenTo(this.userListLayout, "close", this._onLayoutClose);
                this.listenTo(this.usersGridView, "checkAll:change", this._onCheckAllChange);
                this.listenTo(this.usersOrganizedCollection, "reset", this._onCollectionReset);
                this.usersOrganizedCollection.bindToOriginalCollectionEvents();
            },

            _initTooltipsText: function () {
                var limitExceededMessage = LE.translator.translate({
                    key: "LEUserManagement.userList.menuItem.disabled.tooltip.limitExceeded",
                    args: [{key: Config.validators.usersBatchUpdates.maxEntities, isTranslate: false}]
                });
                this.tooltips = {
                    assignSkills: {
                        default: LE.translator.translate("LEFramework.global.captions." + UserListLayout.ACTION_MENU_ITEMS.SKILLS + ".tooltip"),
                        disabled: {
                            agentProfiles: LE.translator.translate("LEUserManagement.userList.menuItem.assignSkills.disabled.tooltip.agentProfiles"),
                            limitExceeded: limitExceededMessage,
                        },
                    },
                    setConcurrency: {
                        default: LE.translator.translate("LEFramework.global.captions." + UserListLayout.ACTION_MENU_ITEMS.CONCURRENCY + ".tooltip"),
                        disabled: {
                            agentProfiles: LE.translator.translate("LEUserManagement.userList.menuItem.setConcurrency.disabled.tooltip.agentProfiles"),
                            limitExceeded: limitExceededMessage,
                        },
                    },
                };
            },

            _initErrorMessagesMap: function () {
                this.errorMessagesMap = {};
                this.errorMessagesMap[ErrorCodes.noDataFound] = LE.translator.translate("LEFramework.entities.user.errors.entity.was.deleted");
                this.errorMessagesMap[ErrorCodes.concurrentModificationConflict] = LE.translator.translate("LEFramework.entities.user.errors.outdated.revision.error");
            },

            _isGroupColumnVisible: function() {
                LEUserManagement.logger.debug("_isGroupColumnVisible", "UserWithProfilesListController:_isGroupColumnVisible");

                var isAcUser = LE.siteSettings.accountSettings.isAcUser();
                var hasGroupStructure = this.agentGroupsCollection.length > 1;
                var hasAgentGroupSettings = LE.sessionManager.hasAgentGroupsFeature();

                return (hasGroupStructure && isAcUser && hasAgentGroupSettings);
            },

            _isUserTypeColumnVisible: function() {
                return LE.sessionManager.hasUserTypeBotFeature();
            },

            _isLobsColumnVisible: function() {
                return LE.sessionManager.hasEntitiesTaggingByLobFeature();
            },

            //happens once
            _onLayoutRender: function() {
                LEUserManagement.logger.debug("_onLayoutRender", "UserWithProfilesListController:_onLayoutRender");
                this.userListLayout.gridRegion.show(this.usersGridView);
            },

            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "UserWithProfilesListController:_onLayoutShown");
                this.usersOrganizedCollection.organize({filterModel:this.usersGridModel});
                this._showMigrationDoneMessage();
            },

            _showMigrationDoneMessage: function() {
                LEUserManagement.logger.debug("_showMigrationDoneMessage", "UserWithProfilesListController:_showMigrationDoneMessage");
                if (LE.context.get("migrationDone")) {
                    LE.context.set("migrationDone", null);
                    LEUserManagement.notifier.showSuccess(LE.translator.translate("LEFramework.upgrade.changed.permissions"));
                }
            },

            _onCollectionReset: function(collection, options) {
                LEUserManagement.logger.debug("_onCollectionReset", "UserWithProfilesListController:_onCollectionReset");
                this._updateActionMenu();
            },

            _onCheckAllChange: function() {
                this._updateActionMenu();
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange", "UserWithProfilesListController:_onPagingChange");
                this.showTableLoader({textLoader: UsersGridView.LOADER_TEXT.LOADING, isShowAnimation: false});
                setTimeout(_.bind( function() {
                    this.usersOrganizedCollection.organize({currentPage:currentPageNumber});
                    this.closeTableLoader();
                }, this), 200);
            },

            _onPagingClear: function () {
                this.usersGridView.clearSelection();
            },

            _onRowSelectorClick: function(options) {
                LEUserManagement.logger.debug("_onRowSelectorClick", "UserWithProfilesListController:_onRowSelectorClick");
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;
                var isExclusiveSelection = !this.hasBatchUpdates;

                if (isChecked) {
                    // on single select mode, clear the old selection
                    if (isExclusiveSelection) {
                        var prevSelectedModel = this.usersSelectableCollection.getSelectedModel();
                        if (!_.isEmpty(prevSelectedModel)) {
                            prevSelectedModel.trigger("model:selection:change", false);
                        }
                    }
                    this.usersSelectableCollection.addToSelection(itemModel, {exclusively: isExclusiveSelection});
                } else {
                    this.usersSelectableCollection.deselectModel(itemModel);
                }
                itemModel.trigger("model:selection:change", isChecked);

                this.usersGridView.updateCheckAll();

                this._updateActionMenu();
            },

            _onRowClick: function(userModel) {
                LEUserManagement.logger.debug("_onRowClick", "UserWithProfilesListController:_onRowClick");
                this._navigateToUser(userModel.id);
            },

            _updateActionMenu: function() {
                LEUserManagement.logger.debug("_updateActionMenu", "UserWithProfilesListController:_updateActionMenu");

                var selectedModels = this.usersSelectableCollection.getSelected();
                var selectedModel = this.usersSelectableCollection.getSelectedModel();
                var selectionLength = selectedModels.length; // selectableCollection.getSelectionLength() is buggy and will not work properly here
                var isSingleSelected = selectionLength === 1;
                var isExportAcUsersData = UserManagementUtilities.hasExportAcUsersData();
                var batchActionsEnabled, allHaveAgentProfile, limitExceeded;
                if (this.hasBatchUpdates) {
                    allHaveAgentProfile = this._allHaveAgentProfile(selectedModels);
                    limitExceeded = selectionLength > Config.validators.usersBatchUpdates.maxEntities;
                    batchActionsEnabled = allHaveAgentProfile && !limitExceeded;
                }

                if (isExportAcUsersData) {
                    this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.EXPORT, enabled: true});
                }
                this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.EDIT, enabled: isSingleSelected});
                this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.DUPLICATE, enabled: isSingleSelected && !this.isBlockAddAndDuplicateUsers});
                if (this.hasBatchUpdates) {
                    var assignSkillsTitle = this._resolveBatchActionTooltip('assignSkills', selectionLength, allHaveAgentProfile, limitExceeded);
                    this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.SKILLS, enabled: batchActionsEnabled, title: assignSkillsTitle});
                }
                this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.DELETE, enabled: isSingleSelected && selectedModel.id !== selectedModel.ACCOUNT_ADMIN_ID});
                if (this.hasBatchUpdates) {
                    var setConcurrencyTitle = this._resolveBatchActionTooltip('setConcurrency', selectionLength, allHaveAgentProfile, limitExceeded);
                    this.channel.trigger("actionMenu:set", {id:UserListLayout.ACTION_MENU_ITEMS.CONCURRENCY, enabled: batchActionsEnabled, title: setConcurrencyTitle});
                }
            },

            _resolveBatchActionTooltip: function (actionKey, selectionLength, allHaveAgentProfile, limitExceeded) {
                if (limitExceeded) {
                    return this.tooltips[actionKey].disabled.limitExceeded;
                } else if (selectionLength > 0 && !allHaveAgentProfile) {
                    return this.tooltips[actionKey].disabled.agentProfiles;
                }
                return this.tooltips[actionKey].default;
            },

            _allHaveAgentProfile: function (models) {
                return !!models.length && models.every(this._hasAgentProfile.bind(this));
            },

            _hasAgentProfile: function (model) {
                var profileIds = model.getProfiles() || [];
                return profileIds.some(this._isAgentProfile.bind(this));
            },

            _isAgentProfile: function(profileId) {
                var roleId;
                var profileModel = this.profilesCollection.get(profileId);
                if (profileModel) {
                    roleId = profileModel.getRoleTypeId().toString();
                    return roleId === ProfileModel.ROLES.AGENT;
                }
            },

            _isACUserMessagingState: function() {
                return LE.siteSettings.accountSettings.isAcUser() && LE.sessionManager.hasAsyncMessagingFeature();
            },

            _onActionMenuSelect: function(selectedItemId) {
                LEUserManagement.logger.debug("_onActionMenuSelect " + selectedItemId, "UserWithProfilesListController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case UserListLayout.ACTION_MENU_ITEMS.ADD:
                        this._onAddSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.EDIT:
                        this._onEditSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.DUPLICATE:
                        this._onDuplicateSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.SKILLS:
                        this._onAssignSkillsSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.DELETE:
                        this._onDeleteSelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.CONCURRENCY:
                        this._onSetConcurrencySelected();
                        break;
                    case UserListLayout.ACTION_MENU_ITEMS.EXPORT:
                        this._exportAllList();
                        break;
                }
            },

            _onAddSelected: function() {
                LEUserManagement.logger.debug("_onAddSelected", "UserWithProfilesListController:_onAddSelected");
                this._navigateToUser(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onEditSelected: function() {
                LEUserManagement.logger.debug("_onEditSelected", "UserWithProfilesListController:_onEditSelected");
                var selectedModel = this.usersSelectableCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToUser(selectedModel.id);
                }
            },

            _onDuplicateSelected: function() {
                LEUserManagement.logger.debug("_onDuplicateSelected", "UserWithProfilesListController:_onDuplicateSelected");
                var selectedModel = this.usersSelectableCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToUser(CONST.ROUTING.DUPLICATE_ITEM + "/" + selectedModel.id, selectedModel);
                }
            },

            _onAssignSkillsSelected: function () {
                LEUserManagement.logger.debug("_onAssignSkillsSelected ", "UserListController:_onAssignSkillsSelected");
                LEUserManagement.showLoader();
                LEUserManagement.logger.debug("Fetching skills collection", "UserListController:_fetchSkillsCollection");
                this.skillsCollection.fetch({
                    success: function () {
                        LEUserManagement.logger.debug("skills collection fetched successfully", "UserListController:_fetchSkillsCollection");
                        LEUserManagement.closeLoader();
                        this._openAssignSkillsDialog();
                    }.bind(this),
                    error: function () {
                        LEUserManagement.logger.error("Skills collection fetch failed", "UserListController:_fetchSkillsCollection");
                        LEUserManagement.closeLoader();
                        LEUserManagement.notifier.showError({content: LE.translator.translate("LEUserManagement.userList.assignSkills.skills.fetch.error"), timeToShow: 6000});
                    }.bind(this)
                });
            },

            _openAssignSkillsDialog: function() {
                LEUserManagement.logger.debug("Initiating and opening the assignSkill dialog ", "UserListController:_openAssignSkillsDialog");
                var innerView = new UsersAssignSkillDialogView({
                    selectedUsers: this.usersSelectableCollection.getSelected(),
                    skillsCollection: this.skillsCollection
                });
                this._openInnerDialog({
                    innerView: innerView,
                    closeDialogCallback: this._closeDialog,
                    saveDialogCallback: this._saveAssignSkillsDialog,
                });
            },

            _saveAssignSkillsDialog: function(changes) {
                LEUserManagement.logger.debug("updating skills on the selected users", "UserListController:_saveAssignSkillsDialog");

                this._closeDialog();

                var request = this._buildAssignSkillsBatchRequest(changes);
                if (!request) {
                    LEUserManagement.logger.warn("no request options, aborting", "UserListController:_saveAssignSkillsDialog");
                    return;
                }

                this._showBatchUpdateConfirm(function () {
                    LEUserManagement.showLoader({
                        text: LE.translator.translate("LEUserManagement.userList.assignSkills.loader.text")
                    });
                    this.usersNotificationManager.registerModuleLeaveNotification({
                        type: ModuleAwareNotificationManager.TYPES.PROGRESS,
                        text: LE.translator.translate("LEUserManagement.userList.assignSkills.progress"),
                    });
                    this.usersCollection.batchUpdate(request);
                }.bind(this));
            },

            _buildAssignSkillsBatchRequest: function (changes) {
                LEUserManagement.logger.debug("building request object for the assign skills batch update", "UserListController:_buildAssignSkillsBatchRequest");

                var ids = _.pluck(changes.selectedUsers, 'id');
                var skillIdsKey = this.usersCollection.model.KEYS.SKILLS;
                var fields = [];

                if (changes.skillsToAdd && changes.skillsToAdd.length) {
                    fields.push({
                        name: skillIdsKey,
                        value: changes.skillsToAdd,
                        operation: 'add',
                    });
                }
                if (changes.skillsToDeduct && changes.skillsToDeduct.length) {
                    fields.push({
                        name: skillIdsKey,
                        value: changes.skillsToDeduct,
                        operation: 'remove',
                    });
                }

                if (fields.length === 0) {
                    return null;
                }

                return {
                    data: {
                        ids: ids,
                        fields: fields,
                    },
                    success: this._onAssignSkillsBatchUpdateSuccess.bind(this),
                    error: this._onAssignSkillsBatchUpdateError.bind(this),
                };
            },

            _onAssignSkillsBatchUpdateSuccess: function () {
                LEUserManagement.logger.debug("Batch update of skills succeed", "UserListController:_onAssignSkillsBatchUpdateSuccess");
                this.usersNotificationManager.unregisterModuleLeaveNotification();
                this.usersGridView.clearSelection();
                // explicitly activate sorting, to refresh the list when filters are on (fixes LE-83865)
                this.usersOrganizedCollection.organize({filterModel:this.usersGridModel});
                LEUserManagement.closeLoader();
                this.usersNotificationManager.showNotification({
                    type: ModuleAwareNotificationManager.TYPES.SUCCESS,
                    text: LE.translator.translate("LEUserManagement.userList.assignSkills.success"),
                });
            },

            _onAssignSkillsBatchUpdateError: function (coll, res) {
                LEUserManagement.logger.error("Batch update of skills failed", "UserListController:_onAssignSkillsBatchUpdateError");
                this.usersNotificationManager.unregisterModuleLeaveNotification();
                LEUserManagement.closeLoader();
                var msg = this._resolveResponseErrorMessage(res) || LE.translator.translate("LEUserManagement.userList.assignSkills.error");
                this.usersNotificationManager.showNotification({
                    type: ModuleAwareNotificationManager.TYPES.ERROR,
                    text: msg,
                });
            },

            _onSetConcurrencySelected: function () {
                LEUserManagement.logger.debug("_onSetConcurrencySelected ", "UserListController:_onSetConcurrencySelected");
                LEUserManagement.showLoader();
                this.settingsCollection.fetch({
                    settingsIds: [SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS],
                    success: function () {
                        LEUserManagement.logger.debug("fetch settings success", "UserListController:_onSettingsFetchSuccess");
                        var maxConversationsSettings = this.settingsCollection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.MAX_CONVERSATIONS).getValue();
                        LEUserManagement.closeLoader();
                        this._openSetConcurrencyDialog(maxConversationsSettings);
                    }.bind(this),
                    error: function () {
                        LEUserManagement.logger.debug("fetch user settings error", "UserListController:_onSettingsFetchError");
                        LEUserManagement.closeLoader();
                        LEUserManagement.notifier.showError({ content: LE.translator.translate("LEUserManagement.userList.siteSettings.errorOnFetching.text"), timeToShow: 6000});
                    }.bind(this)
                });
            },

            _openSetConcurrencyDialog: function (maxConversationsSettings) {
                LEUserManagement.logger.debug("Initiating and opening the setConcurrency dialog ", "UserListController:_openSetConcurrencyDialog");
                var innerView = new UsersSetConcurrencyDialogView({
                    selectedUsers: this.usersSelectableCollection.getSelected(),
                    maxConversationsSettings: maxConversationsSettings,
                    messagingEnabled: this._isACUserMessagingState()
                });
                this._openInnerDialog({
                    innerView: innerView,
                    closeDialogCallback: this._closeDialog,
                    saveDialogCallback: this._saveSetConcurrencyDialog
                });
            },

            _saveSetConcurrencyDialog: function(changes) {
                LEUserManagement.logger.debug("updating max concurrency on the selected users", "UserListController:_saveSetConcurrencyDialog");

                this._closeDialog();

                var request = this._buildSetConcurrencyBatchRequest(changes);
                if (!request) {
                    LEUserManagement.logger.warn("no request options, aborting", "UserListController:_saveSetConcurrencyDialog");
                    return;
                }

                this._showBatchUpdateConfirm(function () {
                    LEUserManagement.showLoader({
                        text: LE.translator.translate("LEUserManagement.userList.setConcurrency.loader.text")
                    });
                    this.usersNotificationManager.registerModuleLeaveNotification({
                        type: ModuleAwareNotificationManager.TYPES.PROGRESS,
                        text: LE.translator.translate("LEUserManagement.userList.setConcurrency.progress"),
                    });
                    this.usersCollection.batchUpdate(request);
                }.bind(this));
            },

            _buildSetConcurrencyBatchRequest: function (changes) {
                LEUserManagement.logger.debug("building request object for the max concurrency batch update", "UserListController:_buildSetConcurrencyBatchRequest");

                var ids = _.pluck(changes.selectedUsers, 'id');
                var maxChatsKey = this.usersCollection.model.KEYS.MAX_NUMBER_OF_CHATS;
                var maxAsyncChatsKey = this.usersCollection.model.KEYS.MAX_NUMBER_OF_CONVERSATIONS;
                var fields = [];

                if (typeof changes.maxChats !== 'undefined') {
                    fields.push({
                        name: maxChatsKey,
                        value: changes.maxChats,
                        operation: 'replace',
                    });
                }
                if (typeof changes.maxAsyncChats !== 'undefined') {
                    fields.push({
                        name: maxAsyncChatsKey,
                        value: changes.maxAsyncChats,
                        operation: 'replace',
                    });
                }

                if (fields.length === 0) {
                    return null;
                }

                return {
                    data: {
                        ids: ids,
                        fields: fields,
                    },
                    success: this._onSetConcurrencyBatchUpdateSuccess.bind(this),
                    error: this._onSetConcurrencyBatchUpdateError.bind(this),
                };
            },

            _onSetConcurrencyBatchUpdateSuccess: function () {
                LEUserManagement.logger.debug("Batch update of max concurrency succeed", "UserListController:_onSetConcurrencyBatchUpdateSuccess");
                this.usersNotificationManager.unregisterModuleLeaveNotification();
                this.usersGridView.clearSelection();
                LEUserManagement.closeLoader();
                this.usersNotificationManager.showNotification({
                    type: ModuleAwareNotificationManager.TYPES.SUCCESS,
                    text: LE.translator.translate("LEUserManagement.userList.setConcurrency.success"),
                });
            },

            _onSetConcurrencyBatchUpdateError: function (coll, res) {
                LEUserManagement.logger.error("Batch update of max concurrency failed", "UserListController:_onSetConcurrencyBatchUpdateError");
                this.usersNotificationManager.unregisterModuleLeaveNotification();
                LEUserManagement.closeLoader();
                var msg = this._resolveResponseErrorMessage(res) || LE.translator.translate("LEUserManagement.userList.setConcurrency.error");
                this.usersNotificationManager.showNotification({
                    type: ModuleAwareNotificationManager.TYPES.ERROR,
                    text: msg,
                });
            },

            _openInnerDialog: function (options) {
                LEUserManagement.logger.debug("Opening the inner dialog ", "UserListController:_openInnerDialog");
                options = options || {};
                this.usersInnerDialogView = options.innerView;
                this.dialog = new Dialog({
                    innerView: this.usersInnerDialogView,
                    moduleName:LEUserManagement.moduleName,
                    context:LE.context
                });
                this.userListLayout.dialogContainerRegion.show(this.dialog);
                this.listenTo(this.usersInnerDialogView, "dialogInnerView:closeDialog", options.closeDialogCallback);
                this.listenTo(this.usersInnerDialogView, "dialogInnerView:onSaveClick", options.saveDialogCallback);
            },

            _closeDialog: function () {
                this.stopListening(this.usersInnerDialogView);
                this.userListLayout.dialogContainerRegion.close();
                this.dialog.close();
            },

            _showBatchUpdateConfirm: function (onConfirm) {
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate("LEUserManagement.userList.batchAction.confirm.title"),
                    content: LE.translator.translate("LEUserManagement.userList.batchAction.confirm.content"),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.continue"),
                        callback: onConfirm,
                    }
                });
            },

            _resolveResponseErrorMessage: function (res) {
                var msg;
                if (res && res.responseError && res.responseError.internalCode &&
                    res.responseError.internalCode in this.errorMessagesMap) {
                    msg = this.errorMessagesMap[res.responseError.internalCode];
                }
                return msg;
            },

            _onDeleteSelected: function() {
                LEUserManagement.logger.debug("_onDeleteSelected", "UserWithProfilesListController:_onDeleteSelected");
                var selectedModel = this.usersSelectableCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    var message = LE.translator.translate({
                        key: "LEUserManagement.userList.delete.confirm.text",
                        args: [{key: SecureUtilities.escapeForHtmlContent(selectedModel.getLoginName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.delete"),
                            callback: _.bind(this._onDeleteConfirmed, this)
                        }
                    });
                }
            },

            _onDeleteConfirmed: function() {
                LEUserManagement.logger.debug("_onDeleteConfirmed", "UserWithProfilesListController:_onDeleteConfirmed");
                var selectedModel = this.usersSelectableCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    LEUserManagement.showLoader();
                    selectedModel.destroy({
                        success: _.bind(this._onDeleteSuccess, this),
                        error: _.bind(this._onDeleteError, this),
                        wait: true
                    });
                }
            },

            _onDeleteSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteSuccess", "UserWithProfilesListController:_onDeleteSuccess");
                this._onSearchDeleting();
                LEUserManagement.closeLoader();
                this.usersSelectableCollection.clearSelection();
            },

            _onSearchDeleting: function () {
                LEUserManagement.logger.debug("_onSearchDeleting", "UserWithProfilesListController:_onSearchDeleting");
                if(this.searchStringValue){
                    this._onSearchRequest({value: this.searchStringValue});
                }
            },

            _onDeleteError: function(model, resp, options) {
                LEUserManagement.logger.info("_onDeleteError", "UserWithProfilesListController:_onDeleteError",resp);
                LEUserManagement.closeLoader();

                var errorMessage = resp && resp.responseError && resp.responseError.message || LE.translator.translate("LEFramework.something.went.wrong");

                if (resp && resp.responseError && (ErrorCodes.removeLastAdminProfile === resp.responseError.internalCode || ErrorCodes.deleteLastAdminUser === resp.responseError.internalCode)) {
                    errorMessage = LE.translator.translate("LEFramework.entities.user.errors.general.lastAdminUser");
                }

                if (resp && resp.responseError && resp.responseError.message) {
                    if (_.include(resp.responseError.message, ErrorCodes.appServer.messages.currentLoggedInUser)) {
                        errorMessage = LE.translator.translate("LEFramework.userList.delete.error.currentLoggedInUser");
                    }
                }

                LEUserManagement.notifier.showError(errorMessage);
            },

            _exportAllList: function() {
                LEUserManagement.logger.debug("_exportAllList", "UserWithProfilesListController:_exportAllList");
                UserManagementUtilities.exportAllList();
            },


            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose", "UserWithProfilesListController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },

            _updateSearchString: function(searchObj) {
               this.searchStringValue = searchObj.value;
            },

            _onSearchRequest: function(searchObj) {
                LEUserManagement.logger.debug("_onSearchRequest", "UserWithProfilesListController:_onSearchRequest");
                var previousSearchValue = this.usersGridModel.getSearchString();
                var currentSearchValue = this._getSearchValue(searchObj);
                if (previousSearchValue !== currentSearchValue){
                    this.showTableLoader({textLoader: UsersGridView.LOADER_TEXT.SEARCHING, isShowAnimation: false});
                    setTimeout(_.bind( function() {
                        this.usersGridModel.setSearchString(currentSearchValue);
                        this.closeTableLoader();
                    }, this), 200);
                }
            },

            _getSearchValue: function(searchObj){
                return (searchObj && searchObj.value) ? searchObj.value : "";
            },

            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews", "UserWithProfilesListController:_unbindEventsDataAndViews");
                if (this.userListLayout) {
                    this.stopListening(this.userListLayout);
                }
                if (this.usersOrganizedCollection) {
                    this.stopListening(this.usersOrganizedCollection);
                    this.usersOrganizedCollection.unBindFromOriginalCollectionEvents();
                }

            },

            _onNavigateOut: function(){
                this._unbindEventsDataAndViews();
            },

            _navigateToUser: function(userId) {
                LEUserManagement.logger.debug("_navigateToUser " + userId, "UserWithProfilesListController:_navigateToUser");
                LEUserManagement.router.navigate("users/"+userId);
            },

            showTableLoader: function(options) {
                LEUserManagement.logger.debug("showTableLoader", "UserWithProfilesListController:showTableLoader");
                this.usersGridView.showLoader(options);
            },

            closeTableLoader: function() {
                LEUserManagement.logger.debug("closeTableLoader", "UserWithProfilesListController:closeTableLoader");
                this.usersGridView.closeLoader();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserListController;
});

